import { formatShortThaiDateFromString, getRelativeTimeString } from '../../utils/dateUtils';

const DateLabel = ({ dateStr }: { dateStr: string }) => {
    return (
        <div>
            <div>{formatShortThaiDateFromString(dateStr)}</div>
            <div className="text-xs text-gray-500">
                {getRelativeTimeString(dateStr)}
            </div>
        </div>
    );
}

export default DateLabel;